(function () {
  function trapFocus(modalEl) {
    const focusable = modalEl.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    function onKeyDown(e) {
      if (e.key !== 'Tab') return;
      if (!focusable.length) return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
    modalEl.addEventListener('keydown', onKeyDown);
    return () => modalEl.removeEventListener('keydown', onKeyDown);
  }

  function initNutritionModal(root) {
    const openBtn = root.querySelector('[data-nutrition-open]');
    const overlay = root.querySelector('[data-nutrition-overlay]');
    const dialog = root.querySelector('[data-nutrition-dialog]');
    const closeBtn = root.querySelector('[data-nutrition-close]');
    const listView = root.querySelector('[data-nutrition-view="list"]');
    const detailView = root.querySelector('[data-nutrition-view="detail"]');
    const backBtn = root.querySelector('[data-nutrition-back]');
    const detailTitle = root.querySelector('[data-nutrition-detail-title]');
    const detailImg = root.querySelector('[data-nutrition-detail-img]');

    if (!openBtn || !overlay || !dialog) return;
    if (!overlay.dataset.portalized) {
    document.body.appendChild(overlay);
    overlay.dataset.portalized = 'true';
  }

    let releaseFocusTrap = null;
    let lastFocus = null;

    function showList() {
      listView.hidden = false;
      detailView.hidden = true;
    }

    function showDetail(title, imgUrl) {
      detailTitle.textContent = title;
      detailImg.src = imgUrl;
      detailImg.alt = title;
      listView.hidden = true;
      detailView.hidden = false;
      backBtn.focus();
    }

    function open() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      document.documentElement.classList.add('no-scroll');
      showList();
      // focus
      closeBtn?.focus();
      releaseFocusTrap = trapFocus(dialog);
    }

    function close() {
      overlay.hidden = true;
      document.documentElement.classList.remove('no-scroll');
      releaseFocusTrap && releaseFocusTrap();
      releaseFocusTrap = null;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openBtn.addEventListener('click', open);
    closeBtn?.addEventListener('click', close);

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', (e) => {
      if (overlay.hidden) return;
      if (e.key === 'Escape') close();
    });

    backBtn?.addEventListener('click', showList);

    root.querySelectorAll('[data-nutrition-item]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const title = btn.getAttribute('data-title') || '';
        const img = btn.getAttribute('data-img') || '';
        if (!img) return;
        showDetail(title, img);
      });
    });
  }

  // Init all on page
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-nutrition-root]').forEach(initNutritionModal);
  });
})();
// External triggers: open existing Nutrition Modal
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-open-nutrition="true"]');
  if (!trigger) return;

  // Find the first nutrition modal on page
  const root = document.querySelector('[data-nutrition-root]');
  if (!root) return;

  const openBtn = root.querySelector('[data-nutrition-open]');
  if (!openBtn) return;

  openBtn.click();
});
